import send from '../../utils/fetch'
import path from '../../../API_URLS.json'

const state = {
    cards: [],
}

const actions = {
    async getFinStatistic({commit}, params) {
        try {
            const response = await send(path.financeStatistic.get, 'POST', { data: params })
            return response.data.result
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async GET_FIN_CARDS({commit}) {
        try {
            let response = await send(path.financeStatistic.get_cards, 'GET'),
            sortedArrayCards = response.data.result.sort((a, b) => a.card_status_id - b.card_status_id);
            commit('SET_CARDS', sortedArrayCards);
            return sortedArrayCards   
        } catch (e) {
            return Promise.reject(e)
        }
    },
}

const mutations = {
    SET_CARDS: (state, payload) => state.cards = payload,
}

const getters = {
    cards: state => state.cards
}

export default {
    state,
    actions,
    mutations,
    getters
}
